import React, { useContext, useEffect, useReducer } from "react";
import axios from "axios";
import reducer from "../reducers/product_reducer";
import { getSecureUrl } from "../utils/helpers";
import {
  products_url,
  update_product_url,
  create_new_product,
  delete_review,
} from "../utils/constants";
import {
  CREATE_NEW_PRODUCT,
  GET_PRODUCTS_BEGIN,
  GET_PRODUCTS_ERROR,
  GET_PRODUCTS_SUCCESS,
  UPDATE_EXISTING_PRODUCT,
  GET_SINGLE_PRODUCT_BEGIN,
  GET_SINGLE_PRODUCT_ERROR,
  GET_SINGLE_PRODUCT_SUCCESS,
} from "../actions";

const initialState = {
  products_loading: false,
  products_error: false,
  products: [],
  new_product: {
    name: "",
    price: 500,
    stock: 10,
    description: "",
    images: [],
    colors: [],
    sizes: [],
    category: "",
    ShopName: "",
    shipping: true,
    featured: false,
  },
  single_product_loading: false,
  single_product_error: false,
  single_product: {},
};

const ProductContext = React.createContext();

export const ProductProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // const fetchProducts = async () => {
  //   dispatch({ type: GET_PRODUCTS_BEGIN });
  //   try {
  //     const prestataireId = "6455165563d63dc5a9b79c62"; // Replace with the actual way you obtain the prestataire's ID
  //     const response = await axios.get(products_url, {
  //       headers: {
  //         Authorization: "Bearer " + localStorage.getItem("access_token"),
  //       },
  //       params: {
  //         prestataireId: prestataireId,
  //       },
  //     });
  //     const { data } = response.data;
  //     dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data });
  //   } catch (error) {
  //     dispatch({ type: GET_PRODUCTS_ERROR });
  //   }
  // };
    // const fetchProducts = async () => {
    //   dispatch({ type: GET_PRODUCTS_BEGIN });
    //   try {
    //     const prestataireId = "6455165563d63dc5a9b79c62"; // Replace with the actual way you obtain the prestataire's ID
    //     const response = await axios.get(products_url, {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem("access_token"),
    //       },
    //       params: {
    //         prestataireId: prestataireId,
    //       },
    //     });
    //     const { data } = response.data;
    //     dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data });
    //   } catch (error) {
    //     dispatch({ type: GET_PRODUCTS_ERROR });
    //   }
    // };

    

// const fetchProducts = async (prestataireId) => {
//   dispatch({ type: GET_PRODUCTS_BEGIN });
//   try {
//     const prestataireId = "6455165563d63dc5a9b79c62"; 
//     const response = await axios.get(products_url, {
//       headers: {
//         Authorization: 'Bearer ' + localStorage.getItem('access_token'),
//       },
//       params: {
//         prestataireId: prestataireId,
//       },
//     });
//     const { data } = response.data;
//     dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data });
//   } catch (error) {
//     dispatch({ type: GET_PRODUCTS_ERROR });
//   }
// };

  const fetchProducts = async () => {
    dispatch({ type: GET_PRODUCTS_BEGIN });
    try {
      const response = await axios.get(products_url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
          ACCESS_ID:localStorage.getItem("access_id"),
          ISADMIN:localStorage.getItem("IsAdmin"),

        },
      });
      const { data } = response.data;
      const secureData = data.map((product) => ({
        ...product,
        image: getSecureUrl(product.image),
        images: product.images
          ? product.images.map((img) => ({ ...img, url: getSecureUrl(img.url) }))
          : [],
      }));
      dispatch({ type: GET_PRODUCTS_SUCCESS, payload: secureData });
    } catch (error) {
      dispatch({ type: GET_PRODUCTS_ERROR });
    }
  };

  // const fetchPresProducts = async () => {
  //   dispatch({ type: GET_PRODUCTS_BEGIN });
  //   try {
  //     const prestataireId = "6455165563d63dc5a9b79c62"; // Replace with the actual way you obtain the prestataire's ID
  //     const response = await axios.get(products_url, {
  //       headers: {
  //         Authorization: "Bearer " + localStorage.getItem("access_token"),
  //       },
  //       params: {
  //         prestataireId: prestataireId,
  //       },
  //     });
  //     const { data } = response.data;
  //     dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data });
  //   } catch (error) {
  //     dispatch({ type: GET_PRODUCTS_ERROR });
  //   }
  // };
  
  

  const fetchSingleProduct = async (id) => {
    dispatch({ type: GET_SINGLE_PRODUCT_BEGIN });
    try {
      const response = await axios.get(`${products_url}${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
        },
      });
      const { data } = response.data;
      if (data.image) {
        data.image = getSecureUrl(data.image);
      }
      if (data.images) {
        data.images = data.images.map((img) => ({
          ...img,
          url: getSecureUrl(img.url),
        }));
      }
      dispatch({ type: GET_SINGLE_PRODUCT_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_SINGLE_PRODUCT_ERROR });
    }
  };

  const deleteProduct = async (id) => {
    try {
      const response = await axios.delete(`${update_product_url}${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
        },
      });
      const { success, message } = response.data;
      return { success, message };
    } catch (error) {
      const { success, message } = error.response.data;
      return { success, message };
    }
  };

  const updateNewProductDetails = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "price" || name === "stock") {
      value = Number(value);
    }
    if (name === "colors" || name === "sizes") {
      value = value.replace(/\s+/g, "");
      if (value === "") {
        value = [];
      } else if (value.indexOf(",") > -1) {
        value = value.split(",");
      } else {
        value = value.split();
      }
    }
    if (name === "shipping" || name === "featured" || name === "isOffer") {
      value = e.target.checked;
    }
    dispatch({ type: CREATE_NEW_PRODUCT, payload: { name, value } });
  };

  const updateExistingProductDetails = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "price" || name === "stock") {
      value = Number(value);
    }
    if (name === "colors" || name === "sizes") {
      value = value.replace(/\s+/g, "");
      if (value === "") {
        value = [];
      } else if (value.indexOf(",") > -1) {
        value = value.split(",");
      } else {
        value = value.split();
      }
    }
    if (name === "shipping" || name === "featured" || name === "isOffer") {
      value = e.target.checked;
    }
    dispatch({ type: UPDATE_EXISTING_PRODUCT, payload: { name, value } });
  };

  // const createNewProduct = async (product) => {
  //   try {
  //     const response = await axios.post(create_new_product, product);
  //     const { success, data } = response.data;
  //     console.log(response.data);
  //     fetchProducts();
  //     return { success, data };
  //   } catch (error) {
  //     const { success, message } = error.response.data;
  //     return { success, message };
  //   }
  // };

  const createNewProduct = async (product) => {
    try {
      const response = await axios.post(create_new_product, product, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
        },
      });
      const { success, data } = response.data;
      await fetchProducts();
      return { success, data };
    } catch (error) {
      const { success, message } = error.response?.data || {
        success: false,
        message: error.message,
      };
      return { success, message };
    }
  };
  const updateProduct = async (id, product) => {
    try {
      const response = await axios.put(`${update_product_url}${id}`, product, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
        },
      });
      const { success, message } = response.data;
      // fetchProducts();
      return { success, message };
    } catch (error) {
      const { success, message } = error.response.data;
      return { success, message };
    }
  };

  const deleteReview = async (productId, reviewId) => {
    try {
      const response = await axios.delete(`${delete_review}${productId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("acces_token"),
        },
        data: {
          reviewId: reviewId, // Include the reviewId in the data object
        },
      });
  
      const { success, message } = response.data;
      fetchSingleProduct(productId);
      return { success, message };
    } catch (error) {
      const { success, message } = error.response.data;
      return { success, message };
    }
  };
  

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <ProductContext.Provider
      value={{
        ...state,
        deleteProduct,
        updateNewProductDetails,
        updateExistingProductDetails,
        createNewProduct,
        fetchProducts,
        // fetchPresProducts,
        fetchSingleProduct,
        updateProduct,
        deleteReview, 
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => {
  return useContext(ProductContext);
};
